import React from "react";
import { useNavigate } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import Header from "../../../components/Header/Header";
import ScrollToTop from "../../../components/Hooks/ScrollToTop";
import SocialLinksSection from "./SocialLinksSection";
import styles from "./SocialLinks.module.scss";

const SocialLinks = () => {
	const navigate = useNavigate();

	return (
		<div className="App">
			<div className="MainContainer">
				<ScrollToTop />
				<Header />

				<div className={styles.ScrollWrapper}>
					<div className={styles.SocialLinksContainer}>
						{/* Top Bar / Back Navigation */}
						<div className={styles.TopBar}>
							<button
								type="button"
								className={styles.BackButton}
								onClick={() => navigate("/Setting")}
								title="Back to Settings"
							>
								<FaAngleLeft />
							</button>
							<div className={styles.HeaderTitles}>
								<h1 className={styles.Title}>Social Links</h1>
								<p className={styles.Subtitle}>
									Connect and manage your external social media accounts
								</p>
							</div>
						</div>

						{/* Interactive Social Links Management Section */}
						<SocialLinksSection isEmbedded={false} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default SocialLinks;
